<span *ngIf="!animation">
    <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 297 297"
        style="enable-background: new 0 0 297 297"
        xml:space="preserve"
    >
        <path
            d="M222.257,0H74.743C54.408,0,37.865,16.543,37.865,36.878v223.243c0,20.335,16.543,36.878,36.878,36.878h147.513
	c20.335,0,36.878-16.543,36.878-36.878V36.878C259.135,16.543,242.592,0,222.257,0z M134.248,255.545
	c0,4.141-3.358,7.499-7.499,7.499h-28.83c-4.141,0-7.499-3.358-7.499-7.499v-28.83c0-4.141,3.358-7.499,7.499-7.499h28.83
	c4.141,0,7.499,3.358,7.499,7.499V255.545z M134.248,184.253c0,4.141-3.358,7.499-7.499,7.499h-28.83
	c-4.141,0-7.499-3.358-7.499-7.499v-28.83c0-4.141,3.358-7.499,7.499-7.499h28.83c4.141,0,7.499,3.357,7.499,7.499V184.253z
	 M206.58,255.545c0,4.141-3.358,7.499-7.499,7.499h-28.83c-4.141,0-7.499-3.358-7.499-7.499v-28.83c0-4.141,3.358-7.499,7.499-7.499
	h28.83c4.141,0,7.499,3.358,7.499,7.499V255.545z M206.58,184.253c0,4.141-3.358,7.499-7.499,7.499h-28.83
	c-4.141,0-7.499-3.358-7.499-7.499v-28.83c0-4.141,3.358-7.499,7.499-7.499h28.83c4.141,0,7.499,3.357,7.499,7.499V184.253z
	 M230.729,94.6c0,5.504-4.463,9.967-9.967,9.967H76.239c-5.504,0-9.967-4.463-9.967-9.967V36.791c0-5.504,4.463-9.967,9.967-9.967
	h144.523c5.504,0,9.967,4.463,9.967,9.967V94.6z"
        />
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
</span>
<span *ngIf="animation"> 
    <svg id="efj1KWOzw4Q1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 297 297" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
        <path d="M222.257,0L74.743,0C54.408,0,37.865,16.543,37.865,36.878v223.243c0,20.335,16.543,36.878,36.878,36.878h147.513c20.335,0,36.878-16.543,36.878-36.878v-223.243C259.135,16.543,242.592,0,222.257,0ZM134.248,255.545c0,4.141-3.358,7.499-7.499,7.499h-28.83c-4.141,0-7.499-3.358-7.499-7.499v-28.83c0-4.141,3.358-7.499,7.499-7.499h28.83c4.141,0,7.499,3.358,7.499,7.499v28.83Zm0-71.292c0,4.141-3.358,7.499-7.499,7.499h-28.83c-4.141,0-7.499-3.358-7.499-7.499v-28.83c0-4.141,3.358-7.499,7.499-7.499h28.83c4.141,0,7.499,3.357,7.499,7.499v28.83Zm72.332,71.292c0,4.141-3.358,7.499-7.499,7.499h-28.83c-4.141,0-7.499-3.358-7.499-7.499v-28.83c0-4.141,3.358-7.499,7.499-7.499h28.83c4.141,0,7.499,3.358,7.499,7.499v28.83Zm0-71.292c0,4.141-3.358,7.499-7.499,7.499h-28.83c-4.141,0-7.499-3.358-7.499-7.499v-28.83c0-4.141,3.358-7.499,7.499-7.499h28.83c4.141,0,7.499,3.357,7.499,7.499v28.83ZM230.729,94.6c0,5.504-4.463,9.967-9.967,9.967h-144.523c-5.504,0-9.967-4.463-9.967-9.967v-57.809c0-5.504,4.463-9.967,9.967-9.967h144.523c5.504,0,9.967,4.463,9.967,9.967v57.809Z"/>
        <rect id="efj1KWOzw4Q3" width="37.631581" height="39" rx="6" ry="6" transform="translate(93.500001 150.5)" opacity="0" stroke-width="0"/>
        <rect id="efj1KWOzw4Q4" width="37.631581" height="39" rx="6" ry="6" transform="translate(166.07895 221.5)" opacity="0" stroke-width="0"/>
        <rect id="efj1KWOzw4Q5" width="37.631581" height="39" rx="6" ry="6" transform="translate(166.07895 150.5)" opacity="0" stroke-width="0"/>
        <rect id="efj1KWOzw4Q6" width="37.631581" height="39" rx="6" ry="6" transform="translate(93.500001 221.5)" opacity="0" stroke-width="0"/>
    </svg>
</span>

